<div class="wrap">
  <div class="header">
    <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active" appChangeColorTheme attribute="color"></fa-icon>
    <h2>Gestion des annonces</h2>
  </div>
  <form class="content-text" [formGroup]="form">
    <div class="zones">
      <div class="top-left">
        <mat-card>
          <div class="editor-angular">
            <angular-editor formControlName="zoneLeft" [config]="editorConfig" placeholder="Zone 1 (Top Left)"></angular-editor>
          </div>
          <div class="image">
            <div class="thumbimage">
              <div class="input_uplaod_perso" appChangeColorTheme attribute="bgc">
                <button type="button" mat-raised-button (click)="lFileInput.click()">Importer une image</button>
                <input type="file" hidden #lFileInput class="input_default_file" (input)="selectImage($event, 'L')" />
              </div>
            </div>
            <div class="filename" *ngIf="leftFilename">
              <div class="name">{{ leftFilename }}</div>
              <fa-icon [icon]="getFaIcon('faTrash')" (click)="deleteFile('L')" matTooltip="Supprimer" matTooltipPosition="above"></fa-icon>
            </div>
          </div>
          <div class="file-upload" *ngIf="leftThumbImage">
            <div class="name" [innerHTML]="leftThumbImage"></div>
            <fa-icon [icon]="getFaIcon('faTrash')" (click)="deleteImage('L')" matTooltip="Supprimer une image" matTooltipPosition="above"></fa-icon>
          </div>
        </mat-card>
        <div class="save" matTooltip="Sauvegarder" matTooltipPosition="above">
          <fa-icon [icon]="getFaIcon('faSave')" (click)="saveTopText('left')" appChangeColorTheme attribute="color"></fa-icon>
        </div>
      </div>
      <div class="top-right">
        <mat-card class="zone-2">
          <div class="editor-angular">
            <angular-editor formControlName="zoneRight" [config]="editorConfig" placeholder="Zone 2 (Top Right)"></angular-editor>
          </div>
          <div class="image">
            <div class="thumbimage">
              <div class="input_uplaod_perso" appChangeColorTheme attribute="bgc">
                <button type="button" mat-raised-button (click)="rFileInput.click()">Importer une image</button>
                <input type="file" hidden #rFileInput class="input_default_file" (input)="selectImage($event, 'R')" />
              </div>
            </div>
            <div class="filename" *ngIf="rightFilename">
              <div class="name">{{ rightFilename }}</div>
              <fa-icon [icon]="getFaIcon('faTrash')" (click)="deleteFile('R')" matTooltip="Supprimer" matTooltipPosition="above"></fa-icon>
            </div>
          </div>
          <div class="file-upload" *ngIf="rightThumbImage">
            <div class="name" [innerHTML]="rightThumbImage"></div>
            <fa-icon [icon]="getFaIcon('faTrash')" (click)="deleteImage('R')" matTooltip="Supprimer une image" matTooltipPosition="above"></fa-icon>
          </div>
        </mat-card>
        <div class="save" matTooltip="Sauvegarder" matTooltipPosition="above">
          <fa-icon [icon]="getFaIcon('faSave')" (click)="saveTopText('right')" appChangeColorTheme attribute="color"></fa-icon>
        </div>
      </div>
    </div>
    <mat-card class="list-zones">
      <div class="title-header">
        <div class="left">Liste des annonces</div>
        <div class="right" (click)="addNotice()">
          <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
          <span>Ajouter une annonce</span>
        </div>
      </div>
      <div class="zone-check">
        <div class="container">
          <span matTooltip="Bloc de gauche"><b>Zone 3</b></span>
          <span matTooltip="Bloc de droite"><b>Zone 4</b></span>
        </div>
      </div>
      <div class="list-announces">
        <ng-container *ngFor="let notice of notices">
          <div class="announce">
            <div class="title">{{ notice.title }}</div>
            <div class="checkbox">
              <mat-checkbox [checked]="notice.isLeftZone" disabled></mat-checkbox>
              <mat-checkbox [checked]="notice.isRightZone" disabled></mat-checkbox>
            </div>
            <div class="actions">
              <fa-icon [icon]="getFaIcon('faPen')" (click)="editNotice(notice)" matTooltip="Éditer" matTooltipPosition="above" appChangeColorTheme attribute="color" ></fa-icon>
              <fa-icon [icon]="getFaIcon('faTrash')" (click)="deleteNotice(notice)" matTooltip="Supprimer" matTooltipPosition="above" appChangeColorTheme attribute="color" ></fa-icon>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-card>
  </form>
</div>
